import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import HighlightText from './HighlightText';
import TutorProfileModal from './TutorProfileModal';
import { allTutors } from '../data/tutorsData';

const { FiStar, FiCheckCircle, FiUser, FiMapPin, FiPhone } = FiIcons;

const Stars = () => (
  <div className="flex items-center gap-0.5">
    {[...Array(5)].map((_, i) => (
      <FiStar key={i} className="w-3.5 h-3.5 fill-current text-yellow-400" />
    ))}
  </div>
);

const featuredTutors = [
  'Anjali Sharma', 'Rohan Verma', 'Pooja Singh',
  'Amit Tiwari', 'Neha Gupta', 'Rahul Mishra',
  'Priya Srivastava', 'Vikram Pandey', 'Sunita Yadav',
];

const TutorCard = ({ tutor, onViewProfile }) => (
  <div className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col">
    <div className="flex gap-4 mb-5">
      <div className="relative flex-shrink-0">
        <img src={tutor.img} alt={tutor.name} className="w-16 h-16 rounded-2xl object-cover border-2 border-red-100 shadow-sm" />
        {tutor.verified && (
          <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 rounded-full flex items-center justify-center border-2 border-white">
            <FiCheckCircle className="text-white w-3 h-3 fill-current" />
          </div>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <h4 className="font-extrabold text-slate-900 text-base tracking-tight truncate">{tutor.name}</h4>
          <span className="text-xs bg-blue-50 text-blue-600 font-bold px-2 py-0.5 rounded-full whitespace-nowrap flex-shrink-0">{tutor.exp}</span>
        </div>
        <p className="text-xs text-gray-500 font-semibold mt-1 mb-2 truncate">{tutor.qualifications}</p>
        <Stars />
      </div>
    </div>
    <div className="flex items-center gap-2 bg-gray-50 px-3 py-2.5 rounded-xl mb-4">
      <FiUser className="text-primary w-4 h-4 flex-shrink-0" />
      <span className="text-sm font-bold text-slate-700 truncate">
        {Array.isArray(tutor.subjects) ? tutor.subjects[0] : tutor.subjects}
      </span>
    </div>
    <div className="flex items-center gap-2 bg-gray-50 px-3 py-2.5 rounded-xl mb-6">
      <FiMapPin className="text-primary w-4 h-4 flex-shrink-0" />
      <span className="text-xs font-semibold text-slate-600 truncate">{tutor.locations.join(', ')}</span>
    </div>
    <div className="flex items-center gap-3 mt-auto">
      <a
        href="tel:+919415905584"
        className="flex-1 bg-primary text-white py-3 rounded-xl text-sm font-extrabold hover:bg-primary-hover transition shadow-sm tracking-wide text-center flex items-center justify-center gap-1.5"
      >
        <FiPhone className="w-3.5 h-3.5" />
        Book Demo
      </a>
      <button
        onClick={() => onViewProfile(tutor)}
        className="flex-1 bg-gray-50 text-slate-700 border border-gray-200 py-3 rounded-xl text-sm font-extrabold hover:bg-gray-100 transition tracking-wide"
      >
        View Profile
      </button>
    </div>
  </div>
);

const Testimonials = () => {
  const [selectedTutor, setSelectedTutor] = useState(null);
  const tutors = allTutors.filter(t => featuredTutors.includes(t.name));

  return (
    <section className="py-20 bg-white" id="tutors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-red-50 text-primary text-xs font-bold px-4 py-2 rounded-full mb-4 border border-red-100 uppercase tracking-widest">
            <FiStar className="w-3.5 h-3.5 fill-current text-yellow-400" />
            Our Expert Tutors
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 tracking-tight">
            Meet Our <HighlightText>Featured Tutors</HighlightText>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tutors.map((tutor, idx) => (
            <TutorCard key={idx} tutor={tutor} onViewProfile={setSelectedTutor} />
          ))}
        </div>
      </div>
      <TutorProfileModal tutor={selectedTutor} onClose={() => setSelectedTutor(null)} />
    </section>
  );
};

export default Testimonials;